import * as React from "react";
import Svg, {
  Defs,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
} from "react-native-svg";

export function MascotSubscribePremium(props: any) {
  return (
    <Svg width="108" height="114" viewBox="0 0 108 114" fill="none" {...props}>
      <G id="Group 488">
        <Rect
          id="Rectangle 2292"
          width="108"
          height="113.87"
          rx="8"
          fill="white"
        />
        <G id="Group 489">
          <G id="Group 396">
            <G id="Group 395">
              <Path
                id="&#208;&#154;&#208;&#190;&#208;&#189;&#209;&#130;&#209;&#131;&#209;&#128; 63"
                d="M80.118 86.0851C80.2099 86.1289 80.2992 86.1786 80.3805 86.2399C80.9348 86.6577 81.3357 87.2491 81.5175 87.922C81.7126 88.6443 81.6424 89.4124 81.3195 90.0872C80.9966 90.7621 80.4425 91.2991 79.7578 91.6003C79.073 91.9016 78.3029 91.9473 77.5872 91.7294L59.1199 86.4536C58.9756 86.4124 58.8266 86.391 58.6782 86.369C58.2662 86.3082 57.8755 86.1418 57.5449 85.8844C57.197 85.6136 56.9304 85.2537 56.7727 84.8442C56.7343 84.7446 56.7092 84.6397 56.7076 84.5329C56.6987 83.9523 57.068 83.2918 57.7129 82.8343C58.6263 82.1862 59.6365 81.3472 59.6365 80.2273V77.5712C59.6365 76.2941 58.4548 75.3474 57.1881 75.5106C54.8601 75.8104 52.5037 75.82 50.1732 75.539C48.9125 75.387 47.7435 76.3319 47.7435 77.6017V89.0068C47.7435 89.779 48.188 90.4822 48.8856 90.8135L57.313 94.8151C57.4036 94.8582 57.4916 94.907 57.572 94.9671C58.1299 95.3842 58.534 95.9767 58.7174 96.6518C58.914 97.3754 58.8441 98.1459 58.5203 98.8223C58.1966 99.4987 57.6406 100.036 56.9536 100.337C56.2667 100.638 55.4945 100.681 54.7779 100.461L36.3129 95.1848C36.1686 95.1435 36.0196 95.1221 35.8711 95.1002C35.4592 95.0394 35.0685 94.8732 34.7379 94.6159C34.39 94.3451 34.1234 93.9849 33.9656 93.5754C33.9273 93.4757 33.9022 93.3709 33.9006 93.2641C33.8917 92.6829 34.2619 92.0223 34.9081 91.5649C35.8213 90.9184 36.8295 90.0799 36.8295 88.961V79.5934C36.8295 76.2187 36.8295 72.9585 36.8295 71.2106C36.8295 70.5778 36.5271 69.9876 36.0329 69.5923C31.7092 66.1334 28.4988 61.4669 26.8176 56.1756C25.0347 50.5642 25.0618 44.5343 26.895 38.9392C28.7283 33.3441 32.2747 28.4673 37.0325 24.999C41.7903 21.5307 47.5185 19.6466 53.4062 19.6134C59.2938 19.5801 65.0428 21.3993 69.8395 24.8137C74.6361 28.2281 78.2374 33.0648 80.1337 38.6388C82.0299 44.2129 82.1251 50.2422 80.4056 55.8733C78.7829 61.1878 75.6214 65.8936 71.3314 69.402C70.8477 69.7975 70.5527 70.383 70.5527 71.0078V80.2699C70.5527 81.0415 70.9966 81.7442 71.6933 82.0758L80.118 86.0851ZM70.4861 45.2593C70.4332 44.7128 70.6073 44.1686 70.9676 43.7543L77.398 36.3593C78.4271 35.1758 77.7556 33.3222 76.2072 33.0725L66.376 31.4868C65.6824 31.3749 65.0984 30.9074 64.8375 30.2551L60.5666 19.5779C59.8961 17.9016 57.5232 17.9016 56.8527 19.5779L52.5995 30.211C52.3291 30.8869 51.7129 31.3625 50.9906 31.4528L41.2513 32.6702C39.5998 32.8767 38.9083 34.8922 40.0851 36.069L47.237 43.2209C47.6864 43.6702 47.8954 44.3064 47.8002 44.9347L46.2111 55.4226C45.9644 57.0509 47.6813 58.2629 49.133 57.4852L57.7969 52.8438C58.3694 52.5372 59.055 52.5275 59.6358 52.8179L68.5731 57.2866C69.9794 57.9897 71.6097 56.87 71.4582 55.3051L70.4861 45.2593Z"
                fill="#251F2C"
              />
            </G>
            <Path
              id="&#208;&#173;&#208;&#187;&#208;&#187;&#208;&#184;&#208;&#191;&#209;&#129; 21"
              d="M59.1654 44.8411C62.2571 44.8411 64.7634 42.3348 64.7634 39.243C64.7634 36.1513 62.2571 33.645 59.1654 33.645C56.0737 33.645 53.5674 36.1513 53.5674 39.243C53.5674 42.3348 56.0737 44.8411 59.1654 44.8411Z"
              fill="#251F2C"
            />
          </G>
          <Path
            id="Vector"
            d="M57.8072 15.8854C58.1698 15.1275 59.2487 15.1275 59.6113 15.8854L66.1407 29.5323C66.2838 29.8313 66.5658 30.0401 66.8936 30.0895L81.6276 32.3113C82.4223 32.4311 82.7581 33.3919 82.2112 33.9807L72.2459 44.7098C72.046 44.925 71.9508 45.2171 71.9856 45.5088L73.8008 60.7261C73.8969 61.5317 73.0441 62.1104 72.3309 61.7235L59.1862 54.5918C58.8887 54.4304 58.5298 54.4304 58.2324 54.5918L45.1878 61.6691C44.4561 62.0661 43.588 61.4474 43.7245 60.6262L46.23 45.5549C46.2828 45.2373 46.1795 44.9137 45.9524 44.6855L35.3119 33.9934C34.734 33.4126 35.0614 32.4213 35.8716 32.2991L50.5249 30.0895C50.8527 30.0401 51.1348 29.8313 51.2778 29.5323L57.8072 15.8854Z"
            stroke="url(#paint0_linear_1206_2413)"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <Path
            id="Vector_2"
            d="M58.7105 17.7422L65.2144 31.2895L79.7589 33.4752L69.9363 44.0144L71.7184 58.9035L58.7105 51.8701L45.7026 58.9035L48.1863 44.0144L37.6621 33.4752L52.2065 31.2895L58.7105 17.7422Z"
            stroke="url(#paint1_linear_1206_2413)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </G>
        <Path
          id="Vector 6918"
          d="M22 13L28 23.3923L43.5885 14.3923L37.5885 4L36.4315 11.5962L29.7942 8.5L29.1569 15.7962L22 13Z"
          stroke="url(#paint2_linear_1206_2413)"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_1206_2413"
          x1="33.9189"
          y1="62.6452"
          x2="65.2685"
          y2="4.21797"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="#E3604F" />
          <Stop offset="1" stop-color="#F094AA" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1206_2413"
          x1="37.6621"
          y1="58.9035"
          x2="64.1384"
          y2="9.38953"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="#E3604F" />
          <Stop offset="1" stop-color="#F094AA" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1206_2413"
          x1="28"
          y1="23.3923"
          x2="24.9809"
          y2="6.216"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stop-color="#E3604F" />
          <Stop offset="1" stop-color="#F094AA" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
